export default {
    breadcrumbs: {
        practice: 'Practice',
        practice_billing: 'Plan & Billing',
    },

    titles: {
        plan_billing: '{practiceName} Plan & Billing',
    },
    active_plan: 'Your active plan',
    cancel_subscription: 'Cancel subscription',
    billing_side_info:
        'Communicate important patient information securely through MedMatch. Your specialty office will benefit from an increased medical referral network.',
    appointment_fee: 'Concierge appointment fee is $.95 for referral received.',
    free_trial_ends: 'Free trial ends on {date}',
    upgrade_now: 'UPGRADE NOW!',
    subscription_canceled: 'Subscription canceled!',
    billing_list: {
        item_1: 'Make and receive referrals',
        item_2: 'Track any referral',
        item_3: 'Workboard push notification',
        item_4: 'Meaningful EMR integration',
        item_5: 'Full analytics',
        item_6: 'Patient SMS notifications & reminders',
    },
    cancel_subscription_info:
        'If you cancel you will not be able to receive referrals on the platform.  Your annual PREMIUM subscription fee will not be refunded. You will be downgraded to Network plan where you can still search providers and services and make referrals.',
    plan_type: 'PLAN TYPE',
    monthly: 'monthly',
    annually: 'annually',
    you_save: 'You save ',
    year: 'year',
    payment_form_list: {
        item_1: 'Search and match providers',
        item_2: 'Make free referrals',
        item_3: 'Insurance prequalification',
        item_4: 'Virtual scheduling',
        item_5: 'Track referrals',
        item_6: '24/7 access to records',
        item_7: 'Patient-centric messaging',
        item_8: 'Connect with peers',
        item_9: 'No contract',
    },
    invite_new_member_warning:
        'A subscription is charged for each provider you add to your practice. Non-provider practice members are added at no additional charge .Please confirm you agree with this!',
    add_location_warning:
        'A subscription is charged for each new location you add to your practice. Please confirm you agree with this!',
}
